"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecycledProjects = void 0;
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var Tags_1 = require("../../Tags");
var CardRequirements_1 = require("../../CardRequirements");
var RecycledProjects = (function (_super) {
    __extends(RecycledProjects, _super);
    function RecycledProjects() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.RECYCLED_PROJECTS,
            cost: 12,
            tags: [Tags_1.Tags.SCIENCE],
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.SCIENCE, 4); }),
            metadata: {
                cardNumber: 'L304',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect(undefined, function (eb) {
                        eb.building(1).played.slash().space().played.startEffect.steel(1);
                    }).br;
                }),
                description: 'After playing a building or space tag, receive a steel resource.',
                victoryPoints: 1,
            },
        }) || this;
    }
    RecycledProjects.prototype.play = function () {
        return undefined;
    };
    RecycledProjects.prototype.onCardPlayed = function (player, card) {
        var numBuildingTags = card.tags.filter(function (tag) { return tag === Tags_1.Tags.BUILDING; }).length;
        var numSpaceTags = card.tags.filter(function (tag) { return tag === Tags_1.Tags.SPACE; }).length;
        if (numBuildingTags > 0 || numSpaceTags > 0)
            player.steel += numBuildingTags + numSpaceTags;
        return undefined;
    };
    RecycledProjects.prototype.getVictoryPoints = function () {
        return 1;
    };
    return RecycledProjects;
}(Card_1.Card));
exports.RecycledProjects = RecycledProjects;
//# sourceMappingURL=RecycledProjects.js.map